import { useEffect, useState } from 'react';

import { Descriptions, Divider, message, Select, Space, Typography } from 'antd';
import { useParams } from 'react-router-dom';

import apiConfig from '../../API_Utils/APIUtil/ApiConfig';
// eslint-disable-next-line import/no-cycle
import CallApi from '../../API_Utils/APIUtil/CallApi';
import { getError } from '../../clientUtils';
import { Layout } from '../../Components/Common';
import CustomHeader from '../../Components/Common/CustomHeader';
import Loading from '../purchase-request/Loading';

const getDiscription = (details) => {
  const getElement = (label, children, key) => ({ label, key, children });
  return [
    getElement('Name', `${details.first_name} ${details.last_name}`),
    getElement('Email', `${details.email}`),
    getElement('Created By', `${details.created_by ?? '-'}`)
  ];
};

const EditUser = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    CallApi(
      apiConfig.permissions.list,
      { page_no: 0, page_size: 1000, sort_by: 'updatedOn', sort_order: 'DESC' },
      null,
      null,
      (res) => setPermissions(res),
      (error) => message.error(getError(error)),
      () => {
        CallApi(
          { ...apiConfig.userManagement.userDetails, path: apiConfig.userManagement.userDetails.path(id) },
          null,
          null,
          setLoading,
          (res) => setDetails({ ...res, user_permissions: res.user_permissions?.map((per) => per.permission) }),
          (error) => message.error(getError(error))
        );
      }
    );
  }, [id]);

  const handleSelect = (permission) => {
    CallApi(
      { ...apiConfig.userManagement.givePermission, path: apiConfig.userManagement.givePermission.path(id) },
      { permission },
      null,
      setEditing,
      (res) => {
        setDetails((prev) => ({ ...prev, user_permissions: [...prev.user_permissions, permission] }));
        message.success(res);
      },
      (error) => message.error(getError(error))
    );
  };

  const handleDeselect = (permission) => {
    CallApi(
      { ...apiConfig.userManagement.revokePermission, path: apiConfig.userManagement.revokePermission.path(id) },
      { permission },
      null,
      setEditing,
      (res) => {
        setDetails((prev) => ({
          ...prev,
          user_permissions: prev.user_permissions.filter((val) => val !== permission)
        }));
        message.success(res);
      },
      (error) => message.error(getError(error))
    );
  };

  if (loading) {
    return (
      <Layout openGroup="users" selected="usersList">
        <Loading />
      </Layout>
    );
  }

  return (
    <Layout openGroup="users" selected="usersList">
      <CustomHeader title="User Management" />
      <Divider />
      <Descriptions items={getDiscription(details)} title="User Info" />
      <Typography.Title level={3}>Permissions</Typography.Title>
      <Select
        disabled={editing}
        fieldNames={{ label: 'permission', value: 'permission' }}
        mode="multiple"
        onDeselect={(value) => handleDeselect(value)}
        onSelect={(value) => handleSelect(value)}
        optionRender={(option) => (
          <Space direction="vertical">
            <Typography.Text>{option?.label}</Typography.Text>
            {option.data.description ? (
              <>
                <Typography.Text type="secondary">{option.data.description}</Typography.Text>
                <Divider style={{ margin: 1 }} />
              </>
            ) : null}
          </Space>
        )}
        options={permissions}
        size="large"
        style={{
          width: '100%'
        }}
        value={details?.user_permissions}
      />
    </Layout>
  );
};

export default EditUser;
